export default "__VITE_ASSET__MWDtNJPV__"